const inscripcion = {
  createInscripcionManual: 'inscripcion/{{uuid_academia}}/manual',
  createInscripcionNodoActivoTareaMensaje: 'inscripcion/{{uuid_inscripcion}}/tarea-mensaje',
  readInscripcionesAlumno: 'inscripciones/{{uuid_academia}}/alumno',
  readInscripcionesAlumnoProyecto: 'inscripcion/{{uuid_alumno}}/{{uuid_proyecto}}',
  readInscripcionesProyecto: 'inscripciones/{{uuid_proyecto}}',
  readInscripcionesProyectoExportar: 'inscripciones/{{uuid_proyecto}}/exportar',
  readInscripcionNodos: '{{uuid_inscripcion}}/nodos_activos',
  readInscripcionNodoActivoTarea: 'inscripcion/{{uuid_inscripcion}}/nodo-activo-tarea',
  readInscripcionNodoActivoTareaMensajes: 'inscripcion/{{uuid_inscripcion}}/tareas-mensajes',
  readInscripcionNodosActivosTareas: 'inscripcion/{{uuid_academia}}/{{uuid_proyecto}}/nodos-activos-tareas',
  updateInscripcionEstado: 'inscripcion/{{uuid_inscripcion}}/acceso-estado',
  updateInscripcionNodoActivoTareaEstado: 'inscripcion/{{uuid_inscripcion}}/nodo-activo-tarea-estado',
  updateInscripcionNodoEstado: 'inscripcion/{{uuid_inscripcion}}'
}

export default inscripcion
